import { render, staticRenderFns } from "./createAndEdit.vue?vue&type=template&id=635a1012&scoped=true&"
import script from "./createAndEdit.vue?vue&type=script&lang=js&"
export * from "./createAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./createAndEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./createAndEdit.vue?vue&type=style&index=1&id=635a1012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a1012",
  null
  
)

export default component.exports